import React, {Component} from 'react';
import Styles from './style.css';
import {langRegister} from "../../services/langRegister";
import cx from "classnames";

class ModalArchive extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    };

    componentWillMount() {}

    _close(){
        this.props.setArchive(false);
    }

    _set(){
        this.props.setArchive(true);
    }

    _renderText(item) {
        return langRegister.get("modal-archive", item);
    }

    render() {
        return (
            <div className={Styles.overlay}>
                <div className={Styles.overlayModal}>
                    <div className={Styles.overlayModalInner}>
                        <img onClick={() => {this._close()}}
                             className={Styles.overlayCloseButton}
                             src={require("../../assets/images/close_icon.svg")}/>
                        <div>
                            <div className={Styles.overlayModalTitle}>
                                {this._renderText("item_1")}
                            </div>
                            {
                                false &&
                                <div className={Styles.overlayModalText}>
                                    <span className={Styles.overlayModalTextBold}>{this._renderText("item_4")}</span> {this._renderText("item_5")}
                                </div>
                            }
                        </div>
                    </div>
                    <div className={Styles.overlayModalButtons}>
                        <div className={Styles.overlayModalButtonsItem}>
                            <div onClick={() => this._set()} className={cx([Styles.overlayModalButtonsItemButton, Styles.buttonActive])}>
                                {this._renderText("item_3")}
                            </div>
                        </div>
                        <div className={Styles.overlayModalButtonsItem}>
                            <div onClick={() => {this._close()}}
                                 className={Styles.overlayModalButtonsItemButton}>
                                {this._renderText("item_2")}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ModalArchive;


// WEBPACK FOOTER //
// ./src/components/modal-archive/component.js